export default __webpack_public_path__ + "static/reconbg1-df16371b70497def3e81df4dc74c8e3a.jpg";